import { callFunction } from './cloudFunctionsClient';
import { isNetworkError } from '../utils/networkUtils';

/**
 * Login-only API calls (small module). Import from here on LoginPage / PasscodeGate
 * so the initial JS bundle does not include the full api/client.ts.
 */

export async function verifyPasscode(
  passcode: string,
): Promise<{ success: boolean; data?: { jwt: string; userType: string }; error?: string }> {
  try {
    const data = await callFunction<{
      success: boolean;
      data?: { jwt: string; userType: string };
      error?: string;
    }>('verifyPasscode', { passcode });
    return data;
  } catch (error) {
    console.error('Error verifying passcode:', error);
    if (isNetworkError(error)) {
      return { success: false, error: 'אין חיבור לאינטרנט. אנא בדוק את החיבור שלך ונסה שוב.' };
    }
    return { success: false, error: 'שגיאה בחיבור לשרת' };
  }
}

export async function verifyContractorLogin(
  vatNumber: string,
  password?: string,
): Promise<{
  success: boolean;
  data?: {
    jwt: string;
    userType: string;
    contractorId: string;
    contractorName: string;
  };
  error?: string;
}> {
  try {
    const data = await callFunction<{
      success: boolean;
      data?: {
        jwt: string;
        userType: string;
        contractorId: string;
        contractorName: string;
      };
      error?: string;
    }>('verifyContractorLogin', { vatNumber, password });
    return data;
  } catch (error) {
    console.error('Error verifying contractor login:', error);
    if (isNetworkError(error)) {
      return { success: false, error: 'אין חיבור לאינטרנט. אנא בדוק את החיבור שלך ונסה שוב.' };
    }
    return { success: false, error: 'שגיאה בחיבור לשרת' };
  }
}

export async function verifyEmployeeLogin(
  passportNumber: string,
  password?: string,
): Promise<{
  success: boolean;
  data?: {
    jwt: string;
    userType: string;
    employeeId: string;
    employeeName: string;
  };
  error?: string;
}> {
  try {
    const data = await callFunction<{
      success: boolean;
      data?: {
        jwt: string;
        userType: string;
        employeeId: string;
        employeeName: string;
      };
      error?: string;
    }>('verifyEmployeeLogin', { passportNumber, password });
    return data;
  } catch (error) {
    console.error('Error verifying employee login:', error);
    if (isNetworkError(error)) {
      return { success: false, error: 'אין חיבור לאינטרנט. אנא בדוק את החיבור שלך ונסה שוב.' };
    }
    return { success: false, error: 'שגיאה בחיבור לשרת' };
  }
}
